//1.Import
import Layout from '../Layout';
import "@lottiefiles/lottie-player";
import SectionQA from '../sections/SectionQA';
//2.Initialization

const layout=new Layout();
const sectionQA=new SectionQA();
//3.Events
window.addEventListener('DOMContentLoaded', function() {
    sectionQA.init()
});

//4. Functions
